<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="注册项配置 " name="first">
        <el-form ref="form" :model="form" label-position="left" label-width="150px">
          <div class="section-body">
            <el-form-item v-for="(item, key) in form" :key="key" :label="item.name">
              <el-switch v-model="item.is_open" active-color="#13ce66" inactive-text="是否开启" inactive-color="#efefef" @change="changeOpen(key)"></el-switch> &nbsp;&nbsp;
              <el-switch v-model="item.is_required" active-color="#13ce66" inactive-text="是否必填" inactive-color="#efefef" @change="changeRequired(key)"></el-switch>
            </el-form-item>
          </div>
          <div class="section-footer with-border content-center">
            <el-button type="primary" @click="save">保存</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="注册协议" name="second">
        <div class="section-white content-padded">
          <el-form ref="form_content" :model="form_content" :rles="rules" label-width="80px">
            <el-form-item label="注册协议" prop="content">
              <vue-html5-editor :content="form_content.content" @change="updateContent"
                                :height="360"></vue-html5-editor>
            </el-form-item>
            <div class="section-footer with-border content-center">
              <el-button type="primary" @click="saveContent">保存</el-button>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
  import { setMemberRegisterSetting, getMemberRegisterSetting, setMemberRegisterContentSetting } from '../../../api/member'
  export default {
    data() {
      return {
        activeName: 'first',
        form: {
          username: {
            name: '姓名',
            is_open: true,
            element_type: 'input',
            is_required: true
          },
          sex: {
            name: '性别',
            is_open: false,
            element_type: 'select',
            is_required: false
          },
          birthday: {
            name: '出生年份',
            is_open: false,
            element_type: 'select',
            is_required: false
          },
          address: {
            name: '家庭地址',
            is_open: false,
            element_type: 'input',
            is_required: false
          },
          email: {
            name: 'email',
            is_open: false,
            element_type: 'input',
            is_required: false
          },
          industry: {
            name: '行业',
            is_open: false,
            element_type: 'select',
            is_required: false,
            items: ['金融/银行/投资','计算机/互联网','媒体/出版/影视/文化','政府/公共事业','房地产/建材/工程','咨询/法律','加工制造','教育培训','医疗保健','运输/物流/交通','零售/贸易','旅游/度假','其他']
          },
          income: {
            name: '年收入',
            is_open: false,
            is_required: false,
            element_type: 'select',
            items: ['5万以下', '5万 ~ 15万', '15万 ~ 30万', '30万以上', '其他']
          },
          edu_background: {
            name: '学历',
            is_open: false,
            element_type: 'select',
            is_required: false,
            items: ['硕士及以上' ,'本科' ,'大专' ,'高中/中专及以下' ,'其他']
          },
          habbit: {
            name: '爱好',
            is_open: false,
            is_required: false,
            element_type: 'checkbox',
            items: [
              { name: '游戏', ischecked: false },
              { name: '阅读', ischecked: false },
              { name: '音乐', ischecked: false },
              { name: '运动', ischecked: false },
              { name: '动漫', ischecked: false },
              { name: '旅游', ischecked: false },
              { name: '家居', ischecked: false },
              { name: '曲艺', ischecked: false },
              { name: '宠物', ischecked: false },
              { name: '美食', ischecked: false },
              { name: '娱乐', ischecked: false },
              { name: '电影/电视', ischecked: false },
              { name: '健康养生', ischecked: false },
              { name: '数码', ischecked: false },
              { name: '其他', ischecked: false }
            ]
          }
        },
        form_content: {
          content: '注册协议'
        },
        rules: {
          content: [
            { required: true, message: "请输入充值协议", trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      updateContent: function (data) {
        this.form_content.content = data
      },
      changeOpen (key) {
        if (key === 'username') {
          this.$message({
            message: '姓名选项必填',
            type: 'warning'
          })
          this.form.username.is_open = true
        }
        // if (key === 'sex') {
        //   this.$message({
        //     message: '性别选项必填',
        //     type: 'warning'
        //   })
        //   this.form.sex.is_open = true
        // }
      },
      changeRequired (key) {
        if (key === 'username') {
          this.$message({
            message: '姓名选项必填',
            type: 'warning'
          })
          this.form.username.is_required = true
        }
        // if (key === 'sex') {
        //   this.$message({
        //     message: '性别选项必填',
        //     type: 'warning'
        //   })
        //   this.form.sex.is_required = true
        // }
      },
      save () {
        setMemberRegisterSetting(this.form).then(response => {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        })
      },
      saveContent() {
        this.$refs['form_content'].validate((valid) => {
            if (valid) {
              setMemberRegisterContentSetting(this.form_content).then(response => {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
              })
            }
        })
      }
    },
    mounted () {
      getMemberRegisterSetting().then(response => {
        this.form_content.content = response.data.data.content_agreement
        delete response.data.data.content_agreement;
        if(response.data.data.username) {
          this.form = response.data.data
          this.form.username.element_type = 'input'
          this.form.sex.element_type = 'select'
          this.form.birthday.element_type = 'select'
          this.form.industry.element_type = 'select'
          this.form.income.element_type = 'select'
          this.form.edu_background.element_type = 'select'
          this.form.habbit.element_type = 'checkbox'
          this.form.address.element_type = 'input'
          this.form.email.element_type = 'input'
        }
      })
    }
  }
</script>
<style type="text/css">
  .setting-header {
    background: #ecf5ff;
  }
</style>



// WEBPACK FOOTER //
// index.vue?6364f228